// Helpers for the "Save / Like" (heart) feature.
//
// The saved-items API (GET /savedItem/listing, stored in home.savedItemsList)
// returns one record per saved entity. Each record carries the entity id under
// a per-type key (carSaleId, carId, carRentalId, garageOwnerId, ...) and/or a
// nested `car` / `rentalCar` object, plus its own `savedItemId` used to delete.
//
// To make the heart show yellow for already-saved items regardless of which id
// field a given listing page uses, we flatten EVERY id-bearing field from each
// saved record into one lookup. Keys we collect from each record (and its
// nested car/rentalCar) are the ones listing/detail pages match against.

const ID_KEYS = [
  'carSaleId',
  'carId',
  'carRentalId',
  'rentalCarId',
  'garageOwnerId',
  'towingOwnerId',
  'towingId',
  'taxiOwnerId',
  'taxiId',
  'carAgentId',
  'spareId',
];

const collectIds = (obj, into) => {
  if (!obj || typeof obj !== 'object') return;
  ID_KEYS.forEach((k) => {
    const v = obj[k];
    if (v !== undefined && v !== null && v !== '') into.add(String(v));
  });
};

// Build a Set of every saved entity id (as strings) from home.savedItemsList.
// Membership check: savedIdSet.has(String(car.carSaleId)) -> render yellow.
export const buildSavedIdSet = (savedItemsList) => {
  const set = new Set();
  if (!Array.isArray(savedItemsList)) return set;
  savedItemsList.forEach((item) => {
    collectIds(item, set);
    collectIds(item?.car, set);
    collectIds(item?.rentalCar, set);
  });
  return set;
};

// Find the savedItemId (needed to DELETE) for a given entity id. Returns the
// savedItemId string, or undefined if the entity isn't currently saved.
export const findSavedItemId = (savedItemsList, entityId) => {
  if (!Array.isArray(savedItemsList) || entityId == null) return undefined;
  const target = String(entityId);
  for (const item of savedItemsList) {
    const ids = new Set();
    collectIds(item, ids);
    collectIds(item?.car, ids);
    collectIds(item?.rentalCar, ids);
    if (ids.has(target)) return item?.savedItemId;
  }
  return undefined;
};
